import { useRouterState } from '@tanstack/react-router'
import { useCallback } from 'react'

import {
  createStorefrontPath,
  storefrontConfig,
  type StorefrontConfig,
} from './storefront.config'

export const useStorefront = () =>
  useRouterState({
    select: (state): StorefrontConfig =>
      state.matches[state.matches.length - 1]?.context.storefront ??
      storefrontConfig,
  })

export const useStorefrontPath = () => {
  const storefront = useStorefront()

  return useCallback(
    <Path extends `/${string}`>(path: Path) =>
      createStorefrontPath(path, storefront),
    [storefront],
  )
}
